module.exports = __webpack_public_path__ + "img/payment_details.c3c6a4bf.svg";